import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Card } from "@/components/panel";

export const InformeFactoresEditor = ({ egresado, onBack }) => {
  const [data, setData] = useState(null);
  const [factores, setFactores] = useState({});
  useEffect(() => {
    api.get(`/admin/egresados/${egresado.id}/informe`).then((r) => { setData(r.data); setFactores(r.data.factores || {}); });
  }, [egresado.id]);

  const save = async () => {
    try {
      const r = await api.put(`/admin/egresados/${egresado.id}/informe`, { factores });
      toast.success(`Informe guardado (${r.data.factores_cargados}/15 factores)`); onBack();
    } catch (err) { toast.error(err.response?.data?.detail || "No se pudo guardar el informe"); }
  };

  if (!data) return <Card className="max-w-2xl">Cargando…</Card>;
  return (
    <Card className="max-w-2xl" data-testid="informe-editor">
      <button onClick={onBack} className="btn-outline text-sm mb-4" data-testid="back-egresados">← Volver</button>
      <h3 className="font-heading font-bold text-xl text-[var(--brand-primary)]">Informe Human AI · {egresado.name}</h3>
      <p className="text-sm text-[var(--brand-text-muted)] mt-1 mb-4">
        Cargá el nivel de cada factor tal como figura en el informe. Las fortalezas respaldadas se calculan solas y el egresado/a decide cuáles publicar. Las empresas nunca ven estos niveles.
      </p>
      <div className="divide-y divide-slate-100">
        {data.catalogo.map((f) => (
          <div key={f.factor} className="flex items-center justify-between gap-3 py-2">
            <span className="text-sm text-[var(--brand-primary)]">{f.factor_nombre}</span>
            <select value={factores[f.factor] || ""} data-testid={`factor-select-${f.factor}`}
              onChange={(e) => setFactores({ ...factores, [f.factor]: e.target.value || null })}
              className="rounded-lg border-2 border-[var(--brand-border)] px-2 py-1.5 text-sm">
              <option value="">Sin dato</option>
              {data.niveles.map((n) => <option key={n} value={n}>{n}</option>)}
            </select>
          </div>
        ))}
      </div>
      {data.fecha_carga && <p className="text-xs text-[var(--brand-text-muted)] mt-3">Última carga: {new Date(data.fecha_carga).toLocaleString("es-AR")} · fuente: {data.fuente}</p>}
      <button onClick={save} className="btn-primary mt-4" data-testid="save-informe">Guardar informe</button>
    </Card>
  );
};
